import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import * as React from 'react';
import { ICompletedUpload } from '../../ducks/files';

interface ICompletedUploadListItemProps {
  file: ICompletedUpload;
}

export const CompletedUploadListItem = React.memo<ICompletedUploadListItemProps>(({ file }) => {
  return (
    <ListItem>
      <ListItemText
        disableTypography
        primary={<Typography variant="body1">{file.name}</Typography>}
        secondary={
          <Typography variant="body2" color="textSecondary" noWrap title={file.url}>
            {file.url}
          </Typography>
        }
      />
    </ListItem>
  );
});
